import ApiRequest from "../utils/ApiRequest"

export default class BookSubCategory {
  static getByBookId = async (id) => {
    return await ApiRequest.set(`v1/books-sub-categories/books/${id}/subcategories`, "GET");
  }
  static getBySubCategoryId = async (id) => {
    return await ApiRequest.set(`v1/books-sub-categories/subcategories/${id}/books`, "GET");
  }

  static create = async (body) => {
    return await ApiRequest.set('v1/books-sub-categories/create-books-subcategories', "POST", body);
  }

  static delete = async (bookId, subCategoryId) => {
    return await ApiRequest.set(`v1/books-sub-categories/${bookId}/${subCategoryId}`, "DELETE");
  }
}
